module.exports = __webpack_public_path__ + "img/GS_Profile-Fazel Mohammed.2c9478be.png";